module.exports = __webpack_public_path__ + "files/e52a24c3fed1e7d3202eedf58796666f.png";